<div
  class="ly-col flex ion-align-items-center ion-justify-content-center ion-padding"
>
  <ion-text color="dark"
    ><h5>{{ 'components.tourIntro.titles.welcome' | translate }}</h5></ion-text
  >
  <ion-text color="primary"
    ><h2 class="ion-no-margin">
      <b>{{ 'netSocialText' | translate }}</b>
    </h2></ion-text
  >
  <p class="ion-text-center">
    {{ 'components.tourIntro.messages.getStarted' | translate }}
  </p>

  <ion-button (click)="getStarted()">
    {{ 'getStartedText' | translate }}
    <ion-icon slot="end" name="arrow-forward"> </ion-icon>
  </ion-button>
</div>
<div class="ly-row ion-justify-content-end">
  <ion-button
    (click)="modal.dismiss()"
    fill="clear"
    size="small"
    color="medium"
    class="ion-margin-bottom ion-margin-end"
  >
    {{ 'components.tourIntro.buttons.skip' | translate }}
  </ion-button>
</div>
